import LoadMoreCards from './LoadMoreCards';

export default LoadMoreCards;
